import axios from "@/app/axios";
import {ALERT, CLEAR_PURCHASE} from "@/actions/types";

const register = (phone_number: string, password: string, password_confirmation: string) => {
  return axios.post("register", {
    phone_number,
    password,
    password_confirmation
  });
};

const login = (phone_number: string, password: string, remember?: boolean) => {
  return axios
    .post("login", {
      phone_number,
      password,
      remember: remember || false
    })
    .then((response: {data: {user: object}}) => {
      if (response.data.user) {
        localStorage.setItem("user", JSON.stringify(response.data.user));
      }

      return response.data;
    });
};

const requestSMSCode: (phone_number: string) => (dispatch: (any:any) => void) => Promise<any> = (phone_number: string) => {
    return (dispatch) => {
        return axios
            .post("reset-pass-mobile", {
                phone_number
            })
            .then((response: {data: {result: number, count_down: number}}) => {
                if (response.data.result) {
                    return response.data.count_down;
                }
                return -1;
            }).catch(res => {
                dispatch({
                    type: ALERT,
                    payload: { message: {...res.response.data} }
                });
                dispatch({
                    type: CLEAR_PURCHASE
                });
                return res;
            });
    }
};

const logout = () => {
  axios.post('/logout');
  localStorage.removeItem("user");
};

const updateLocalUser = () => {
  return axios
      .get("user")
      .then((response: {data: any}) => {
        if (response.data.access_token) {
          localStorage.setItem("user", JSON.stringify(response.data));
        }

        return response.data;
      });
};

const AuthService = {
    register,
    login,
    logout,
    requestSMSCode,
    updateLocalUser
};

export default AuthService;
